import React, { useState, useEffect } from 'react';
import './App.css';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import ForgotPassword from './components/ForgotPassword';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import RequestAccountDeletion from './components/RequestAccountDeletion';

interface User {
  id: number;
  email: string;
  name: string;
  role: string;
}

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);
  const [showForgotPassword, setShowForgotPassword] = useState(false);

  useEffect(() => {
    // Check if user is already logged in
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('user');
    
    if (token && userData) {
      try {
        const parsedUser = JSON.parse(userData);
        setUser(parsedUser);
        setIsAuthenticated(true);
      } catch (error) {
        // Invalid user data, clear storage
        localStorage.removeItem('token');
        localStorage.removeItem('user');
      }
    }
    setLoading(false);
  }, []);

  const handleLogin = (token: string, userData: User) => {
    setUser(userData);
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
    setIsAuthenticated(false);
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-imola-primary mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  const isRequestDelete = window.location.hash === '#request-delete';

  return (
    <div className="App">
      {isRequestDelete ? (
        <RequestAccountDeletion />
      ) : isAuthenticated && user ? (
        <Dashboard user={user} onLogout={handleLogout} />
      ) : showForgotPassword ? (
        <ForgotPassword onBackToLogin={() => setShowForgotPassword(false)} />
      ) : (
        <Login onLogin={handleLogin} onForgotPassword={() => setShowForgotPassword(true)} />
      )}
    </div>
  );

  // If path starts with /admin, use basename '/admin' for admin app
  // if (window.location.pathname.startsWith('/admin')) {
  //   return (
  //     <Router basename="/admin">
  //       <Routes>
  //         <Route path="/request-delete" element={<RequestAccountDeletion />} />
  //         <Route path="/*" element={
  //           isAuthenticated && user ? (
  //             <Dashboard user={user} onLogout={handleLogout} />
  //           ) : (
  //             <Login onLogin={handleLogin} />
  //           )
  //         } />
  //       </Routes>
  //     </Router>
  //   );
  // }

  // // Otherwise, render public router for /request-delete at root
  // return (
  //   <Router>
  //     <Routes>
  //       <Route path="/request-delete" element={<RequestAccountDeletion />} />
  //     </Routes>
  //   </Router>
  // );
}

export default App;
